<div class="cart-item">
  <div class="d-flex justify-content-between">
    <div class="d-flex">
      <p class="quantity">{{ item?.quantity }}X</p>
      <img
        style="width: 18px; height: 18px"
        src="assets/images/tickets/ticket.png"
      />
      <p class="ticket-title" style="font-size: larger">
        {{ helpers.getElementTranslatedName(item?.ticket) }}
      </p>
    </div>
    <div class="d-flex">
      <p class="ticket-title px-2 mb-0" style="font-size: larger">
        <ng-container *ngIf="item?.ticket?.price !== 0">
          <span
            [innerHTML]="
              item?.ticket?.price
                | toVat
                | customCurrency : 'SAR' : 'symbol' : '#555770' : 28
            "
          ></span>
        </ng-container>

        <ng-container *ngIf="item?.ticket?.price === 0">
          {{ "free" | translate }}
        </ng-container>
      </p>
      <img
        *ngIf="!review"
        (click)="deleteItem()"
        class="time-icons"
        style="cursor: pointer"
        src="assets/images/tickets/trash.png"
      />
    </div>
  </div>
  <div class="d-flex gap-3">
    <div class="d-flex gap-1 align-items-center">
      <img class="time-icons" src="assets/images/tickets/calendar.svg" />
      <p class="mb-0 ticket-title" style="direction: ltr">
        {{
          item?.schedule?.startAt * 1000
            | localizedDate : "EEEE, MMM d, y" : translate.currentLang
        }}
      </p>
    </div>

    <div
      *ngIf="item?.ticket?.isScheduled && dateTimes?.length > 0 && review"
      class="d-flex align-items-center gap-1"
    >
      <img class="time-icons" src="assets/images/tickets/clock.svg" />
      <p class="mb-0 ticket-title" style="direction: ltr">
        {{ item?.time?.time }}
      </p>
    </div>
  </div>
  <div
    *ngIf="item?.ticket?.isScheduled && dateTimes?.length > 0 && !review"
    class="d-flex justify-content-between mt-3 align-items-center"
  >
    <p class="mb-0 choose-ticket" style="padding-inline-start: 0">
      {{ "choose-time" | translate }}
    </p>
    <ng-select
      [placeholder]="item?.time?.id ? '' : ('hour' | translate)"
      [virtualScroll]="true"
      (change)="selectTime($event)"
      [ngModel]="item?.time?.id"
    >
      <ng-option *ngFor="let time of dateTimes" [value]="time.id">
        {{ time.time }}
      </ng-option>
    </ng-select>
  </div>
  <div
    class="d-flex gap-1 mt-3 align-items-start"
    *ngIf="!item?.ticket?.isScheduled || dateTimes?.length == 0"
  >
    <img
      class="time-icons"
      *ngIf="!review"
      src="assets/images/tickets/clock.svg"
    />
    <p class="mb-0 ticket-title" style="padding-inline-start: 0">
      {{ "come-anytime" | translate }}
      {{
        item?.schedule?.startAt * 1000
          | localizedDate : "hh:mm a" : translate.currentLang
      }}
      {{ "to" | translate }}
      {{
        item?.schedule?.endAt * 1000
          | localizedDate : "hh:mm a" : translate.currentLang
      }}
    </p>
  </div>
</div>
